export default {
  ru: {
    menu: {
      title_1: 'Привлечение клиентов',
      title_2: 'Создание команды',
      title_3: 'Подключение бизнесов',
      btn: 'Зарегистрироваться',
      login: 'Войти'
    },
    connect: {
      title: 'Привлечение клиентов',
      dsc: `Пользуетесь SWITIPS? Вы можете получать кэшбэк и скидки сами, а можете заодно делиться выгодами умного потребления с другими людьми и зарабатывать на этом деньги. Умеете создавать поток клиентов или просто привлекать людей? Этот навык можно продать на рынке труда за фиксированную зарплату, а можно превратить в дополнительный источник дохода по реферальной программе SWITIPS.`,
      btn: 'Начать зарабатывать на кэшбэке'
    },

    benefit: {
      shops: {
        title: 'Реферальная<br> клиентская программа:',
        ol: [
          'Регистрируйтесь на кэшбэк-платформе, покупайте GOLD-карту, пользуйтесь повышенным кэшбэком и акциями привилегированного пакета SWITIPS',
          'Приглашайте на платформу знакомых, рекламируйте умные покупки в интернете',
          'Получайте 15% от кэшбэка с покупок всех приглашенных, премию 17 евро, если кто-то из них купит GOLD-пакет, и деньги за покупки тех, кого приведут на платформу ваши приглашенные'
        ]
      },
      you: {
        title: 'Преимущества',
        ol: [
          'Простая и прозрачная реферальная программа, в которую вы попадаете бесплатно – как только покупаете GOLD-пакет',
          'Все выгоды умного потребления плюс неограниченная прибыль за счет покупок приглашенных'
        ],
        btn: 'Зарегистрироваться'
      },
      title_long: 'Создание многоуровневой клиентской базы:',
      desc_long: 'Вы можете получать деньги за покупки до 20 уровней клиентов – тех, кого пригласили сами, и тех, кого привлекают они. Для этого необходимо приобрести мини-франшизу с оптовым количеством GOLD-карт для клиентов по выгодной цене, а при реализации карт – еще большая выгода! Чем больше ваша клиентская команда, тем выше прибыль.'
    },
    dsc: {
      title: 'Пример',
      paragraph_1: `Среднестатистическая семья из трех человек ежемесячно тратит около 700 евро.`,
      paragraph_2: `Средний кэшбэк составляет 10%. Это 70 евро в месяц, 840 евро в год на новые покупки, отдых, развлечения.`,
      additional: `А если эта семья зарегистрировалась на платформе по вашей рекомендации, вы получаете годовое вознаграждение 126 евро. И так – с каждого привлеченного клиента. Больше клиентов – больше прибыль!`
    }

  },
  en: {
    menu: {
      title_1: 'Attracting customers',
      title_2: 'Creating a team',
      title_3: 'Business Connection',
      btn: 'Sign up',
      login: 'Sign in'
    },
    connect: {
      title: 'Attracting customers',
      dsc: `Using SWITIPS? You can get cashback and discounts yourself, and you can share the benefits of smart consumption with other people and make money from it.  You know how to create a stream of customers or just attract people?  This skill can be sold on the labor market for a fixed salary, or it can be turned into an additional source of income through the SWITIPS referral program.`,
      btn: 'Start earning cashback'
    },

    benefit: {
      shops: {
        title: `Referral<br> client program:`,
        ol: [
          'Register on the cashback platform, buy a GOLD card, use the increased cashback and shares of the preferred SWITIPS package',
          'Invite your friends on a platform, advertise smart purchases on the Internet',
          'Get 15% of cashback from purchases of all those invited, a premium of 17 euros if someone buys the GOLD package, and money for purchases of those whom your invitees bring to the platform'
        ]
      },
      you: {
        title: 'Benefits:',
        ol: [
          'A simple and clear referral program that you get for free - as soon as you buy a GOLD package',
          'All the benefits of smart consumption plus unlimited profits through inviting purchases'
        ],
        btn: 'Sign up'
      },
      title_long: 'Creating a multi-level customer base:',
      desc_long: 'You can earn money for purchases of up to 20 levels of customers – those who are invited themselves, and those who are attracted to them. To do this, you need to buy a mini-franchise with a wholesale number of GOLD-cards for customers at a bargain price, and when selling cards – even greater benefit! The larger your customer team, the higher the profit.'
    },
    dsc: {
      title: 'Example:',
      paragraph_1: `The average family of three monthly spends about 700 euros. Middle cashback is 10%.`,
      paragraph_2: `This is 70 euros per month, 840 euros per year for new purchases, leisure, entertainment.`,
      additional: `And if the family was registered on the platform on your recommendation, you will receive an annual fee of EUR 126. And so - with each attracted client. More customers - more profit!`
    }

  },
  ua: {
    menu: {
      title_1: 'Залучення клієнтів',
      title_2: 'Створення команди',
      title_3: 'Підключення бізнесів',
      btn: 'Зареєструватися',
      login: 'Увійти'
    },
    connect: {
      title: 'Залучення клієнтів',
      dsc: `Користуєтеся SWITIPS? Ви можете отримувати кешбек і знижки самі, а можете заодно ділитися вигодами розумного споживання з іншими людьми і заробляти на цьому гроші. Вмієте створювати потік клієнтів або просто залучати людей? Цей навик можна продати на ринку праці за фіксовану зарплату, а можна перетворити в додаткове джерело доходу по реферальній програмі SWITIPS.`,
      btn: 'Почати заробляти на кешбек'
    },

    benefit: {
      shops: {
        title: 'Реферальна<br> клієнтська програма:',
        ol: [
          'Реєструйтеся на кешбек-платформі, купуйте GOLD-карту, користуйтеся підвищеним кешбеком і акціями привілейованого пакета SWITIPS',
          'Запрошуйте на платформу знайомих, рекламуйте розумні покупки в інтернеті',
          'Отримуйте 15% від кешбек з покупок всіх запрошених, премію 17 євро, якщо хтось із них купить GOLD-пакет, і гроші за покупки тих, кого приведуть на платформу ваші запрошені'
        ]
      },
      you: {
        title: 'Переваги:',
        ol: [
          'Проста і прозора реферальная програма, в яку ви потрапляєте безкоштовно - як тільки купуєте GOLD-пакет',
          'Всі вигоди розумного споживання плюс необмежений прибуток за рахунок покупок запрошених'
        ],
        btn: 'Зареєструватися'
      },
      title_long: 'Створення багаторівневої клієнтської бази:',
      desc_long: 'Ви можете отримувати гроші за покупки до 20 рівнів клієнтів – тих, кого запросили самі, і тих, кого приваблюють вони. Для цього необхідно придбати міні-франшизу з оптовою кількістю GOLD-карт для клієнтів за вигідною ціною, а при реалізації карт - ще більша вигода! Чим більше ваша клієнтська команда, тим вище прибуток.'
    },
    dsc: {
      title: 'Приклад:',
      paragraph_1: `Середньостатистична сім'я з трьох осіб щомісяця витрачає близько 700 євро.`,
      paragraph_2: `Середній кешбек становить 10%. Це 70 євро в місяць, 840 євро в рік на нові покупки, відпочинок, розваги.`,
      additional: `А якщо ця сім'я зареєструвалася на платформі по вашій рекомендації, ви отримуєте річну винагороду 126 євро. І так - з кожного залученого клієнта. Більше клієнтів - більше прибуток!`
    }

  },
  kz: {
    menu: {
      title_1: 'Клиенттерді тарту',
      title_2: 'Команда құру',
      title_3: 'Іскерлік байланыс',
      btn: 'Тіркелу',
      login: 'Кіру'
    },
    connect: {
      title: 'Клиенттерді тарту',
      dsc: `SWITIPS пайдалану? Ақшалай қаражаттар мен жеңілдіктерді өзіңіз ала аласыз, ақылды тұтынудың пайдасын басқа адамдармен бөлісе аласыз және одан ақша табасыз. Сіз клиенттердің ағындарын жасауға немесе адамдарды тартуға қабілетті бе? Бұл дағдылық еңбек нарығында тұрақты жалақыға сатылуы мүмкін немесе SHITIPS бағдарламасы бойынша қосымша табыс көзі бола алады.`,
      btn: 'Кэшбэк-те ақша табуды бастау'
    },

    benefit: {
      shops: {
        title: 'Түйіндеме<br> клиент бағдарламасы:',
        ol: [
          'Кэшбэк платформасына тіркеліп, Gold карточкасын сатып алыңыз, SWITIPS артықшылықты пакетінің жоғарылатылған ақшалай қаражатын және акцияларын пайдаланыңыз',
          'Таныстыруды платформаға шақыру, Интернетте ақылды сатып алуды жарнамалау',
          'Шақырылғандардың барлығынан сатып алудың 15% -ын алады, егер біреу GOLD пакетін сатып алса және сіздің шақырылғандарыңыз платформаға әкелетін ақшаға 17 евро сыйақы алады'
        ]
      },
      you: {
        title: 'Артықшылықтары:',
        ol: [
          'GOLD пакетін сатып алғаннан кейін сіз тегін алуға болатын қарапайым және мөлдір бағдарлама',
          'Ақылды тұтынудың барлық артықшылықтары, сонымен қатар сатып алуға шақыру арқылы шексіз пайда'
        ],
        btn: 'Тіркелу'
      },
      title_long: 'Көп деңгейлі клиенттік базаны құру:',
      desc_long: 'Сіз сатып алу үшін ақша алуға дейін 20 деңгейдегі клиенттер – өздері шақырған және олар тартатын адамдар. Ол үшін тиімді бағамен клиенттерге арналған Gold-карталардың көтерме саны бар шағын франшизаны сатып алу қажет, ал карталарды сату кезінде – тағы да үлкен пайда! Сіздің клиенттік команда неғұрлым көп болса, пайда соғұрлым жоғары.'
    },
    dsc: {
      title: 'Мысал:',
      paragraph_1: `Орташа үш отбасы айына 700 евро жұмсайды. Орташа есеп айырысу 10% құрайды.`,
      paragraph_2: `Бұл айына 70 евро, жаңа сатып алу, демалыс, ойын-сауық үшін жылына 840 евро.`,
      additional: `Ал егер бұл отбасы Сіздің ұсынысыңызға сәйкес платформаға тіркелсе, Сізге жылына 126 еуро сыйақы беріледі. Және де - әрбір тартылған клиенттен. Көптеген клиенттер - көп пайда!`
    }

  }
}
